// src/Components/LoadingComp/LoadingScreen.js
import React from 'react';
import './loadingscreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <h1>ධම්ම සමාධි බෞද්ධ මධ්‍යස්ථානය, ශ්‍රී ලංකාව</h1>
        <h2>DHAMMA SAMADHI BUDDHIST CENTER, SRILANKA</h2>
        <img 
          src="/dharma.webp"  // This points to public/dharma.png
          alt="Wheel of Dharma" 
          className="spinning-wheel"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default LoadingScreen;